import React from 'react';
export function Footer() {
  return <footer className="bg-paper border-t border-ink/10 px-6 md:px-12 py-16" data-id="element-27">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-10 items-start" data-id="element-28">
        <div data-id="element-29">
          <p className="font-serif-display text-2xl text-ink" data-id="element-30">
            Co<span className="text-sun italic" data-id="element-31">.</span>
          </p>
          <p className="mt-4 text-ink-soft text-[13px] leading-[1.85] max-w-xs" data-id="element-32">
            A women's travel house. Launching 2027.
          </p>
        </div>
        <div className="md:text-center" data-id="element-33">
          <p className="font-serif-display italic text-ink/60 text-base md:text-lg leading-relaxed" data-id="element-34">
            Come as you are. <br data-id="element-35" />
            Leave changed.
          </p>
        </div>
        <div className="md:text-right" data-id="element-36">
          <a href="#waitlist" className="eyebrow !text-ink hover:!text-sun transition-colors" data-id="element-37">
            Join the waitlist →
          </a>
          <p className="mt-10 eyebrow !text-muted" data-id="element-38">© 2026 Co.</p>
        </div>
      </div>
    </footer>;
}